export default class Debounce {
  fn: (...args: any[]) => void;
  delay: number;
  context: object;
  timeout: any;

  constructor(fn, delay = 0, context = null) {
    this.fn = fn;
    this.delay = delay;
    this.context = context;
  }

  debounce(...args) {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => this.fn.apply(this.context, args), this.delay);
  }

  cancel() {
    clearTimeout(this.timeout);
  }
}
